import React from "react";
import { Route,Routes } from "react-router-dom";
import Dashboard from "../consultant/Dashboard/dashboard";
import AddCandidate from "../consultant/addeditcandidate/addcandidate";
import EditCandidate from "../consultant/addeditcandidate/editcandidate";
import ConsultantProfile from "../consultant/addconsultantprofile";
import EditMultipleConsultant from "../consultant/editconsultantprofile";
import GetCandidatesByEmployerUserID from "../consultant/addeditcandidate/getcandidatesbyemployeruserid";
import GetHiredCandidatesByUserID from "../consultant/gethiredcandidatesbyuserID";
import GetListOfNonHiredCandidates from "../consultant/getlistofnonhiredcandidates";
import ConfigureIntitialScreeningTest from "../consultant/configureinitialscreeningtest";
import GetInterviewScheduledCandidates from "../consultant/getinterviewscheduledcandidates";
import GetInterviewCompletedCandidates from "../consultant/getinterviewcompletedcandidates";
import AddQuestions from "../consultant/addquestions";
import ViewInterviewQuestions from "../consultant/questions";
import EditScreeningTest from "../consultant/editinterviewscreeningtest";
import EditQuestions from "../consultant/updatequestion";
import CommentInterviewCompletedCandidates from "../consultant/commentinterviewcompletedcandidates"
import ViewCandidateDetailsByCandidateGUid from "../consultant/viewcandidatedetailsbycandidateguid";
import ViewInterviewCompletedCandidateDetails from "../consultant/viewinterviewcompletedcandidatedetails";
import VendorProfile from "../consultant/addvendor";
import ListOfVendors from "../consultant/listofvendors";
import EditVendorProfile from "../consultant/editvendor";
import ShareDetailsToVendor from "../consultant/sharecandidatedetailstovendor";
import ShareInterviewDetailsToVendor from "../consultant/shareinterviewdetailstovendor";
import Addbulkdata from "../consultant/addbulkdata";
import Addbulkquestions from "../consultant/addbulkquestions";
import AddUser from "../consultant/adduser";
import ListOfUsers from "../consultant/listofusers";
import Masking from "../consultant/masking";
import JobRolesList from "../consultant/jobroleslist";
import AddJobRole from "../consultant/addjobRole";
import EditJobRole from "../consultant/editjobrole";
import SendEmail from "../consultant/sendemailverificationcode";
import ListOfLeads from "../consultant/listofleads";
import AddLead from "../consultant/addlead";
import EditLead from "../consultant/editlead";
import SelectedLeads from "../consultant/selectedleads";
import ListOfJobPosts from "../consultant/listofjobposts";
import AddJobPosts from "../consultant/addjobposts";
import EditJobPosts from "../consultant/editjobposts";
import Addbulkleads from "../consultant/addbulkleads";
import ViewJobPosts from "../consultant/viewjobposts";
import ViewHotList from "../consultant/viewhotlist"
import ListSavedVideos from "../consultant/listsavedvideos";
import ViewListSavedVideos from "../consultant/viewsavedvideoscandidatedetails";
import SelectedVideos from "../consultant/selectedvideos";
import ListOfMovedVideos from "../consultant/movedvideos";
import ListOfDeletedVideos from "../consultant/deletedvideos";
import ViewMovedVideoCandidateDetails from "../consultant/viewmovedvideocandidatedetails";
import ViewSavedVideoCandidateDetails from "../consultant/viewsavedvideoscandidatedetails";
import ViewDeletedVideoCandidateDetails from "../consultant/viewdeletedvideocandidatedetails";
import ListOfHotList from "../consultant/listofhotlist";
import AddHotList from "../consultant/addhotlist";
import EditHotList from "../consultant/edithotlist";
import AddbulkHotList from "../consultant/addbulkhotlist";
import SelectedHotList from "../consultant/selectedhotlist";
import UserDashboard from "../consultant/userdashboard";
import CEMDashboard from "../consultant/cemdashboard";
import ShareAllDetailsToVendor from "../consultant/shareallcandidatedetailstovendor";
import GenerateAIQuestions from "../consultant/generateaiquestions";
import ViewMatchedCandidates from "../consultant/viewmatchedcandidates";
import ResumeParser from "../consultant/resumeparser";
import  ViewMatchedCandidatebyId  from "../consultant/viewmatchedcandidatebyid";
import ListOfClients from "../Admin/listofclients";
import AddClientDetails from "../Admin/addclients"
import EditClientDetails from "../Admin/editclients";
import CvComparision from "../consultant/cvcomparision";
import ResumeParserwithAi from "../consultant/resumeparserwithai";
import ReplicateBenchCandidatesProfile from "../consultant/replicatebenchcandidatesprofile";
import EditUser from "../consultant/edituser";
import AddCandidateFromDocument from "../consultant/addcandidatefromdocument";
import AddInternalCandidateFromDocument from "../consultant/report/addinternalcandidatefromdocument";
import ViewLead from "../consultant/viewlead";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { CountryProvider } from "../contexts/countrycodecontext.js";
import PricingSection from "../subscription/pricingplans.js";
import Payment from "../subscription/payment.js";
import SubscriptionHistory from "../subscription/subscriptionhistory.js";
import Reports from "../consultant/report/reports.js";
import ReportViewCandidateDetailsByCandidateGUid from "../consultant/report/reportviewcandidatedetails.js";
import ViewMatchedLinkedinCandidates from "../consultant/viewmatchedlinkedincandidates.js";
import SelectedLinkedinCandidatesList from "../consultant/selectedlinkedincandidateslist.js";
import ViewAppliedCandidatesforJob from "../consultant/viewappliedcandidatesforjob.js";
import ViewAppliedCandidateDetailsbyId from "../consultant/viewappliedcandidatedetailsbyid.js";
import InternalBench from "../consultant/report/internalbench.js";
import ShareCandidateDetailstoSubvendor from "../consultant/report/sharecandidatedetailstosubvendor.js";
import ShareReportsCandidateDetailstoSubvendor from "../consultant/report/sharereportscandidatedetailstosubvendor.js";
import ViewMatchedInternalCandidates from "../consultant/viewmatchedinternalcandidates.js";
import SelectedInternalCandidatesList from "../consultant/selectedinternalcandidateslist.js";
import ViewInternalCandidateDetailsByCandidateGUid from "../consultant/viewinternalcandidatedetailsbycandidateguid.js";
import ShareJobDetailstoBenchSales from "../consultant/sharejobdetailstobenchsalesteam.js";
import LinkedInContacts from "../consultant/linkedincontacts.js";
import ViewMatchedLinkedinContacts from "../consultant/viewmatchedlinkedincontacts.js";
import SelectedLinkedinContactsList from "../consultant/selectedlinkedincontactslist.js";
import ListOfResources from "../consultant/listofresources.js";
import ShareBenchCandidateDettoRecruiter from "../consultant/sharebenchcandidatedetailstorecruiter.js";
import BenchViewCandidateDetailsByCandidateGUid from "../consultant/report/benchviewcandidatedetails.js";
import EditInternalBenchCandidate from "../consultant/report/editinternalbenchcandidate.js";
import { JoinMeetingButton } from "../home/joinmeeting.js";
import ResumeFormatter from "../consultant/resumeformatter.js";
import OverallRecruiterstatistics from "../consultant/overallstatistics.js";
import BenchsalesStats from "../consultant/benchsalesstats.js";
import SelectedLeadsGenericMail from "../consultant/selectedleadscustommail.js";
import ViewEvaluationResults from "../consultant/viewevaluationresults.js";
import ViewEvaluationPersonDetails from "../consultant/viewevaluationpersondetails.js";
import ViewBenchSalesReports from "../consultant/report/viewbenchsalesreports.js";
import DiceCandidatesList from "../consultant/Dice/dicecandidateslist.js";
import CandidateProfile from "../consultant/Dice/candidateprofile.js";
import DiceSearch from "../consultant/Dice/dicesearch.js";  
import SendFollowupEmail from "../consultant/sendfollowupmailfrombenchsalesreports.js";
import CandidateDetailsPage from "../consultant/Dice/candidatedetailspage.js";
import OverallEvaluationResults from "../consultant/overallevaluationresults.js";
import OverallOutreachCandidates from "../consultant/overalloutreachcandidates.js";
import OverallInternalBenchOutreachCandidates from "../consultant/overallinternalbenchoutreachcandidates.js";
import EvaluationViewCandidateDetailsByCandidateGUid from "../consultant/Evaluationviewcandidatedetailsbycandidateguid.js";
import OutreachViewCandidateDetailsByCandidateGUid from "../consultant/Outreachviewcandidatedetailsbycandidateguid.js";
import EvaluationEachViewCandidateDetailsByCandidateGUid from "../consultant/Evaluationeachviewcandidatedetailsbycandidateguid.js";
import Cleanup from "../consultant/cleanup.js";
import AddInternalCandidate from "../consultant/report/addinternalcandidate.js";
import EditInternalCandidate from "../consultant/report/editinternalcandidate.js";
import DiceCredits from "../consultant/Dice/remainingdicecredits.js";




const ConsultantRoutes = ()=>{
    return(
        <div>
          <CountryProvider>
        <Routes>
      <Route path="/Employer/Dashboard" element= {<Dashboard/>}/>
      <Route path="/Employer/SubscriptionPlans" element= {<PricingSection/>}/>
      <Route path="/Employer/SubscriptionHistory" element= {<SubscriptionHistory/>}/>
      <Route path="/Employer/Payment" element= {<Payment/>}/>
      <Route path="/Employer/AddCandidate" element= {<AddCandidate/>}/>
      <Route path="/Employer/EditBenchCandidate" element= {<EditCandidate/>}/>
      <Route path="/Employer/Profile" element= {<ConsultantProfile/>}/>
      <Route path="/Employer/EditMultipleConsultant" element= {<EditMultipleConsultant/>}/>
      <Route path="/Employer/HiredCandidatesByUserid" element= {<GetHiredCandidatesByUserID/>}/>
      <Route path="/Employer/GetCandidatesByEmployerUserID" element= {<GetCandidatesByEmployerUserID/>}/>
      <Route path="/Employer/NonHiredCandidates" element= {<GetListOfNonHiredCandidates/>}/>
      <Route path="/Employer/ConfigureInitialScreeningTest" element= {<ConfigureIntitialScreeningTest/>}/>
      <Route path="/Employer/GetCandidatesByEmployerUserID" element= {<GetCandidatesByEmployerUserID/>}/>
      <Route path="/Employer/GetInterviewScheduledCandidates" element= {<GetInterviewScheduledCandidates/>}/>
      <Route path="/Employer/GetInterviewCompletedCandidates" element= {<GetInterviewCompletedCandidates/>}/>
      <Route path="/Employer/Questions" element= {<ViewInterviewQuestions/>}/>
      <Route path="/Employer/AddQuestions" element= {<AddQuestions/>}/>
      <Route path="/Employer/EditInterviewScreeningTest" element= {<EditScreeningTest/>}/>
      <Route path="/Employer/EditQuestions/:qGuid" element={<EditQuestions />} />
      <Route path="/Employer/CommentInterviewCompletedCandidates" element={<CommentInterviewCompletedCandidates />} />
      <Route path="/Employer/ViewCandidateDetailsByCandidate" element={<ViewCandidateDetailsByCandidateGUid />} />
      <Route path="/Employer/ViewInterviewCompletedCandidateDetails" element={<ViewInterviewCompletedCandidateDetails/>} />
      <Route path="/Employer/AddClientProfile" element={<VendorProfile/>} />
      <Route path="/Employer/ListofClients" element={<ListOfVendors/>} />
      <Route path="/Employer/EditClientProfile" element={<EditVendorProfile/>} />
      <Route path="/Employer/ShareDetailstoVendor" element={<ShareDetailsToVendor/>} />
      <Route path="/Employer/ShareInterviewDetailstoVendor" element={<ShareInterviewDetailsToVendor/>} />
      <Route path="/Employer/AddBulkCandidates" element={<Addbulkdata/>} />
      <Route path="/Employer/AddBulkQuestions" element={<Addbulkquestions/>} />
      <Route path="/Employer/AddUser" element={<AddUser/>} />
      <Route path="/Employer/ListofUsers" element={<ListOfUsers/>} />
      <Route path="/Employer/Masking" element={<Masking/>} />
      <Route path="/Employer/JobRoles" element={<JobRolesList/>} />
      <Route path="/Employer/AddJobRole" element={<AddJobRole/>} />
      <Route path="/Employer/EditJobRole" element={<EditJobRole/>} />
      <Route path="/Employer/SendEmail" element={<SendEmail/>} />
      <Route path="/Employer/ListOfLeads" element={<ListOfLeads/>} />
      <Route path="/Employer/AddLead" element={<AddLead/>} />
      <Route path="/Employer/EditLead" element={<EditLead/>} />
      <Route path="/Employer/ListOfLeads/SelectedLeads" element={<SelectedLeads/>} />
      <Route path="/Employer/ReplicateBenchCandidate" element={<ReplicateBenchCandidatesProfile/>} />
      <Route path="/Employer/AddJobPosts" element={<AddJobPosts/>} />
      <Route path="/Employer/ListOfJobPosts" element={<ListOfJobPosts/>} />
      <Route path="/Employer/EditJobPosts" element={<EditJobPosts/>} />
      <Route path="/Employer/AddBulkLeads" element={<Addbulkleads/>} />
      <Route path="/Employer/ViewJobPosts" element={<ViewJobPosts/>} />
      <Route path="/Employer/ListSavedVideos" element={<ListSavedVideos/>} />
      <Route path="/Employer/ViewListSavedVideos" element={<ViewListSavedVideos/>} />
      <Route path="/Employer/ListSavedVideos/SelectedVideos" element={<SelectedVideos/>} />
      <Route path="/Employer/ListOfMovedVideos" element={<ListOfMovedVideos/>} />
      <Route path="/Employer/ListOfDeletedVideos" element={<ListOfDeletedVideos/>} />
      <Route path="/Employer/ViewSavedVideoCandidateDetails" element={<ViewSavedVideoCandidateDetails/>} />
      <Route path="/Employer/ViewDeletedVideoCandidateDetails" element={<ViewDeletedVideoCandidateDetails/>} />
      <Route path="/Employer/ViewMovedVideoCandidateDetails" element={<ViewMovedVideoCandidateDetails/>} />
      <Route path="/Employer/ListofStaffingContacts" element={<ListOfHotList/>} />
      <Route path="/Employer/AddStaffingContact" element={<AddHotList/>} />
      <Route path="/Employer/EditStaffingContact" element={<EditHotList/>} />
      <Route path="/Employer/AddBulkSubVendorList" element={<AddbulkHotList/>} />
      <Route path="/Employer/ListofStaffingContacts/SelectedSubVendorList" element={<SelectedHotList/>} />
      <Route path="/Employer/UserDashboard" element= {<Dashboard/>}/>
      <Route path="/Employer/CEMDashboard" element= {<CEMDashboard/>}/>
      <Route path="/Employer/ViewStaffingContact" element={<ViewHotList/>} />
      <Route path="/Employer/ShareDetails" element={<ShareAllDetailsToVendor/>} />
      <Route path="/Employer/GenerateAIQuestions" element={<GenerateAIQuestions/>} />
      <Route path="/Employer/ViewMatchedInternalCandidates" element={<ViewMatchedInternalCandidates/>} /> 
      <Route path="/Employer/AIResumeInsights" element={<ResumeParserwithAi/>} /> 
      <Route path="/Employer/ViewMatchedCandidatebyId" element={<ViewMatchedCandidatebyId/>} /> 
      <Route path="/Admin/ListofallClients" element={<ListOfClients/>} /> 
      <Route path="/Admin/AddClients" element={<AddClientDetails/>} /> 
      <Route path="/Admin/EditClients" element={<EditClientDetails/>} /> 
      <Route path="/Employer/EditUser" element={<EditUser/>} /> 
      <Route path="/Employer/AddCandidatefromDocument" element={<AddCandidateFromDocument/>} /> 
      <Route path="/Employer/AddInternalCandidateFromDocument" element={<AddInternalCandidateFromDocument/>} />
      <Route path="/Employer/ViewLead" element={<ViewLead/>} /> 
      <Route path="/Employer/Reports" element={<Reports/>} /> 
      <Route path="/Employer/InternalBench" element={<InternalBench/>} /> 
      <Route path="/Employer/AddInternalCandidate" element={<AddInternalCandidate/>} /> 
      <Route path="/Employer/EditInternalCandidate" element={<EditInternalCandidate/>} /> 
      <Route path="/Employer/ShareCandidatedetailstoSubVendor" element={<ShareCandidateDetailstoSubvendor/>} /> 
      <Route path="/Employer/ReportViewCandidateDetailsByCandidateGUid" element={<ReportViewCandidateDetailsByCandidateGUid />} />
      <Route path="/Employer/ViewMatchedLinkedinCandidates" element={<ViewMatchedLinkedinCandidates />} />
      <Route path="/Employer/ViewMatchedLinkedinCandidates/SelectedLinkedinCandidatesList" element={<SelectedLinkedinCandidatesList/>} />
      <Route path="/Employer/ListOfJobPosts/ViewAppliedCandidatesforJob" element={<ViewAppliedCandidatesforJob/>} />
      <Route path="/Employer/ViewAppliedCandidatesforJob/ViewAppliedCandidateDetailsbyId" element={<ViewAppliedCandidateDetailsbyId/>} />
      <Route path="/Employer/ShareReportsCandidateDetailstoSubvendor" element={<ShareReportsCandidateDetailstoSubvendor/>} /> 
      <Route path="/Employer/ViewMatchedInternalCandidates/SelectedInternalCandidatesList" element={<SelectedInternalCandidatesList/>} /> 
      <Route path="/Employer/ViewMatchedInternalCandidates/ViewInternalCandidateDetailsByCandidateGUid" element={<ViewInternalCandidateDetailsByCandidateGUid/>} /> 
      <Route path="/Employer/ShareJobDetailstoBenchSales" element={<ShareJobDetailstoBenchSales/>} />    
      <Route path="/Employer/ListofLinkedInContacts" element={<LinkedInContacts/>} />  
      <Route path="/Employer/ViewMatchedLinkedinContacts" element={<ViewMatchedLinkedinContacts />} />
      <Route path="/Employer/ViewMatchedLinkedinContacts/SelectedLinkedinContactsList" element={<SelectedLinkedinContactsList/>} />
      <Route path="/Employer/ListOfResources" element={<ListOfResources/>} />
      <Route path="/Employer/ShareBenchCandidateDettoRecruiter" element={<ShareBenchCandidateDettoRecruiter/>} />
      <Route path="/Employer/BenchViewCandidateDetailsByCandidateGUid" element={<BenchViewCandidateDetailsByCandidateGUid/>} />
      <Route path="/Employer/EditInternalBenchCandidate" element={<EditInternalBenchCandidate/>} />

    
    
      {/* <Route path="/Employer/BenchSubmissions" element={<BenchSubmissions/>} /> */}
      <Route path="/Employer/Joinmeeting" element={<JoinMeetingButton/>} /> 
      <Route path="/Employer/ResumeFormatter" element={<ResumeFormatter/>} /> 
      <Route path="/Employer/OverallRecruiterstatistics" element={<OverallRecruiterstatistics/>} /> 
      <Route path="/Employer/BenchSalesStat" element={<BenchsalesStats/>} />
      <Route path="/Employer/ListOfLeads/SelectedLeadsCustomMail" element={<SelectedLeadsGenericMail/>} />
      <Route path="/Employer/ViewEvaluationResults" element={<ViewEvaluationResults/>} />
      <Route path="/Employer/ViewEvaluationPersonDetails" element={<ViewEvaluationPersonDetails/>} />
      <Route path="/Employer/ViewBenchSalesReports" element={<ViewBenchSalesReports/>} />
      <Route path="/Employer/DiceSearch" element={<DiceSearch/>} />
      <Route path="/Employer/DiceCandidatesList" element={<DiceCandidatesList/>} />
      <Route path="/candidate/:profileId" element={<CandidateProfile />} />
      <Route path="/Employer/SendFollowUpEmail" element={<SendFollowupEmail />} />
      <Route path="/Employer/candidate-details/:id" element={<CandidateDetailsPage />} />
      <Route path="/Employer/OverallEvalutionResults" element={<OverallEvaluationResults />} />
      <Route path="/Employer/OverallOutreachCandidates" element={<OverallOutreachCandidates />} />
      <Route path="/Employer/OverallInternalBenchOutreachCandidates" element={<OverallInternalBenchOutreachCandidates />} />
      <Route path="/Employer/EvaluationViewCandidateDetailsByCandidateGUid" element={<EvaluationViewCandidateDetailsByCandidateGUid />} />
      <Route path="/Employer/OutreachViewCandidateDetailsByCandidateGUid" element={<OutreachViewCandidateDetailsByCandidateGUid />} />
      <Route path="/Employer/EvaluationEachViewCandidateDetailsByCandidateGUid" element={<EvaluationEachViewCandidateDetailsByCandidateGUid />} />
      <Route path="/Employer/Cleanup" element={<Cleanup/>} /> 
            <Route path="/Employer/DiceCredits" element={<DiceCredits/>} /> 

                 </Routes>   
               

        </CountryProvider>
        </div>
    )
}
export default ConsultantRoutes
